export default "__VITE_ASSET__BaACw4HU__"